module.exports = __webpack_public_path__ + "img/shusong5.2b7de2f0.jpg";